<template>
  <div class="campo">
    <div class="etiq-1">{{ etiqueta }}</div>
    <div v-if="valor">{{ valor }}</div>
    <CampoVacio v-else />
  </div>
</template>

<script>
export default {
  props: {
    valor: { type: [String, Number], required: false, default: null },
    etiqueta: { type: String, required: false, default: "" }
  }
};
</script>

<style scoped>
.etiq-1 {
  font-size: 80%;
  color: #0053a2;
}
.campo {
  padding-bottom: 0.5rem;
}
</style>
